import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount"; 
import { getFirestore, collection, query, where, getDocs, orderBy, updateDoc, setDoc, Timestamp, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import swal from 'sweetalert'; 
import {useNavigate } from "react-router-dom";

function SendBulkSMS() {

    const db = getFirestore();
    const auth = getAuth();
    const [userId, setUserId] = useState("");
    const [userName, setUserName] = useState();
    const [pointValue, setPointValue] = useState("");
    const [status, setStatus] = useState("");
    const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
    const [purchasedSMS, setPurchasedSMS] = useState();
    const [myissuedSMS, setMyissuedSMS] = useState();
    const [myTotalSMS, setMyTotalSMS] = useState();
    
    const [totalPoints, setTotalPoints] = useState(0);
    const [redeemedPoints, setRedeemedPoints] = useState(0);
    const [uniquePhoneCount, setUniquePhoneCount] = useState(0);
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState("");
    const [defaultSenderId, setdefaultSenderId] = useState();


    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
            const uid = user.uid;
            setUserId(uid);
            loadSettings(uid);
            fetchUserStatus(uid);
            fetchTotalAwardedPoints(uid);
            fetchTotalRedeemedPoints(uid);
            countUniquePhones(uid);
            fetchGlobalSettings();
        }
        });
        return () => unsubscribe();
    }, []);

    const loadSettings = async (uid) => {
        const docRef = doc(db, "settings", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            setPointValue(data.pointValue || "");   
        }
    };
    
    const fetchUserStatus = async (uid) => {
        const userQuery = query(collection(db, "users"), where("userId", "==", uid));
        const querySnapshot = await getDocs(userQuery);
        querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            setStatus(data.status || "Unsubscribed");
            setUserName(data.businessName);
            setPurchasedSMS(data.purchasedSMS);
            setMyissuedSMS(data.issuedSMS);
            const totalSMS = parseInt(data.issuedSMS) + data.purchasedSMS;
            setMyTotalSMS(totalSMS);
    
            const subscriptionEnd = data.subscriptionEnd?.toDate?.();
            if (subscriptionEnd) {
            const now = new Date();
            const isExpired = now > subscriptionEnd;
            setSubscriptionStatus(isExpired ? "Expired" : "Active");
            } else {
            setSubscriptionStatus("Unsubscribed");
            }
        });
    };

    const fetchGlobalSettings = async() => {
        const userQuery = query(collection(db, "globalSettings"), where("docID", "==", "wqSDO1OEBintZqf0svF6"));
        const querySnapshot = await getDocs(userQuery);
        querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            setdefaultSenderId(data.defaultSenderId);
        });
    };
    
    const fetchTotalAwardedPoints = async (uid) => {
        const rewardRef = collection(db, "rewardCustomers");
        const q = query(rewardRef, where("businessId", "==", uid));
        
        try {
            const querySnapshot = await getDocs(q);
            let total = 0;
            querySnapshot.forEach((doc) => {
            const data = doc.data();
            total += data.points || 0;
            });
            setTotalPoints(total);
        } catch (error) {
            console.error("Error fetching awarded points:", error);
        }
    };

        const fetchTotalRedeemedPoints = async (uid) => {
        const redeemedRef = collection(db, "redeemedPoints");
        const q = query(redeemedRef, where("businessId", "==", uid));

        try {
            const querySnapshot = await getDocs(q);
            let total = 0;
            querySnapshot.forEach((doc) => {
            const data = doc.data();
            total += data.pointsUsed || 0;
            });
            setRedeemedPoints(total);
        } catch (error) {
            console.error("Error fetching redeemed points:", error);
        }
        };


        const countUniquePhones = async (uid) => {
        const rewardRef = collection(db, "rewardCustomers");
        const q = query(rewardRef, where("businessId", "==", uid));

        try {
            const querySnapshot = await getDocs(q);
            const phoneSet = new Set();

            querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.phone) {
                phoneSet.add(data.phone);
            }
            });

            setUniquePhoneCount(phoneSet.size);
        } catch (error) {
            console.error("Error counting unique phone numbers:", error);
        }
        };
    //read data from firebase 

    const [campaigns, setCampaigns] = useState([]);

    useEffect(() => {
        const fetchCampaigns = async () => {
            const q = query(
                collection(db, "smsCampaigns"),
                where("businessId", "==", userId),
                orderBy("sentAt", "desc") // Order by most recent first
            );

            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setCampaigns(data);
        };

        fetchCampaigns();
    }, [userId]);

    //logics

    const [recipients, setRecipients] = useState("All my clients");
    const [message, setMessage] = useState("");
    const [campaignName, setCampaignName] = useState("");
    const [loading, setLoading] = useState(false);

    //
    const previewText = message.length > 0
    ? message.substring(0, 37) + "..."
    : "Your promotional message will appear here...";


    const charactersPerUnit = 100;
    const costPerUnit = 1;


    // Calculations
    const messageLength = message.length;
    const unitsPerMessage = Math.ceil(messageLength / charactersPerUnit);
    const estimatedCost = unitsPerMessage * costPerUnit * uniquePhoneCount;

    //check available messages if is more that what is needed 

    //console.log(myTotalSMS);


    const handleSend = async () => {
        if (!message || !campaignName) {
            swal("Missing Fields", "Please enter both message and campaign name.", "warning");
            return;
        }

        if(estimatedCost > myTotalSMS ){
            swal('insufficient SMS', "You have insufficient SMS credit to send Bulk SMS. Please top up your SMS balance to continue.", 'info').then(()=>{
                navigate("/settings");
            })
            return;
        }

        if (subscriptionStatus === "Expired"){
            swal('Subscription Expired', "Your subscription to this platform has expired. Renew your subscription to continue", 'info').then(()=>{
                navigate("/settings");
            })
            return;
        }

        setLoading(true);
        try {
            const phonesQuery = query(
            collection(db, "rewardCustomers"),
            where("businessId", "==", userId)
            );
            const querySnapshot = await getDocs(phonesQuery);

            const phoneSet = new Set();
            querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.phone) phoneSet.add(data.phone);
            });

            const phoneArray = Array.from(phoneSet);

            const signedMessage = `${message}\n- from: ${userName}`;

            for (const phone of phoneArray) {
            await sendSms(signedMessage, phone);
            }

            // Save to Firestore under smsCampaigns
            const campaignRef = doc(collection(db, "smsCampaigns"));
            await setDoc(campaignRef, {
            businessId: userId,
            campaignName,
            message,
            totalRecipients: phoneArray.length,
            sentAt: Timestamp.now(),
            smsCost:estimatedCost,
            docId:campaignRef.id
            });
            
            // Deduct SMS from user's balance
            const issued = Number(myissuedSMS) || 0;
            const purchased = Number(purchasedSMS) || 0;

            let updatedIssued = issued;
            let updatedPurchased = purchased;

            if (estimatedCost <= issued) {
                updatedIssued -= estimatedCost;
            } else {
                const remainingCost = estimatedCost - issued;
                updatedIssued = 0;
                updatedPurchased -= remainingCost;
            }

            const userDocRef = doc(db, "users", userId);
            await updateDoc(userDocRef, {
                issuedSMS: String(updatedIssued),
                purchasedSMS: updatedPurchased,
            });

            swal("Success", "SMS Campaign sent successfully!", "success").then(() => {
                // Just refresh values via state or redirect instead of hard reload
                window.location.reload();
            });


           
        } catch (error) {
            console.error("Error sending SMS campaign:", error);
            swal("Error", "There was an issue sending your SMS campaign.", "error");
        } finally {
            setLoading(false);
        }
    };


          const sendSms = async (message, phoneNumber) => {
                const auth = getAuth();
                const user = auth.currentUser;
            
                if (!user) {
                    console.error("User not logged in");
                    return;
                }
            
                try {
                    const token = await user.getIdToken();
            
                    const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-bulk-sms", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ message, phoneNumber }),
                    });
            
                    const data = await response.json();
            
                    if (response.ok) {
                        console.log("sent..");
                        return false;
                    } else {
                        console.log("sent..");
                        return false;
                    }
                } catch (err) {
                        console.log("sent..");
                        return false;
                }
          };











  return (
    <div className="dashBCont">
    <LeftBar />
    <div className="dashBcontA">
    <NavBarAccount />
        <Container className="py-4">
        <Card className="p-4">
            <h3 className="mb-4">Send Promotional SMS</h3>
            <Row>
            <Col lg={6}>
            <Form onSubmit={handleSend}>

                <Form.Group className="mb-3">
                    <Form.Label  className="text-muted small">Recipients</Form.Label>
                    <Form.Select
                    value={recipients}
                    onChange={(e) => setRecipients(e.target.value)}
                    >
                    <option>All my clients</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label  className="text-muted small">Enter your Message. Include your Business Name and Contact etc</Form.Label>
                    <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Type your promotional message here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    />
                    <Form.Text className="text-muted">{message.length} characters</Form.Text>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label  className="text-muted small">Enter Campaign Name</Form.Label>
                    <Form.Control
                    placeholder="eg. Madaraka Day Promo"
                    value={campaignName}
                    onChange={(e) => setCampaignName(e.target.value)}
                    />
                </Form.Group>

                    <Button  className="w-100 myPrimaryBtn" onClick={handleSend} disabled={loading}>
                    {loading ? (
                        <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                        </>
                    ) : (
                        <>
                        <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                        Send SMS Campaign
                        </>
                    )}
                    </Button>

                </Form>

            </Col>

            <Col lg={6}>
                <Card className="mb-3">
                <Card.Body>
                    <Card.Title>Campaign Preview</Card.Title>
                    <div className="bg-light p-3 rounded border-start border-primary border-4">
                    <p className="mb-0">
                        <strong>From:</strong> {defaultSenderId}<br />
                        <strong>Message:</strong> {previewText}
                    </p>
                    </div>
                </Card.Body>
                </Card>

                <Card>
                <Card.Body>
                    <Card.Title>Estimated Reach</Card.Title>
                    <div className="d-flex justify-content-between">
                    <span>Total Recipients:</span>
                    <span className="fw-medium">{uniquePhoneCount}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                    <span>Number of characters:</span>
                    <span className="fw-medium">{messageLength}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                    <span>Cost per 100 characters:</span>
                    <span className="fw-medium">KSH 1</span>
                    </div>
                    <div className="d-flex justify-content-between">
                    <span>Estimated Cost:</span>
                    <span className="fw-medium">KSH {estimatedCost}</span>
                    </div>

                    <div className="d-flex justify-content-between">
                    <span>Expected Delivery:</span>
                    <span className="fw-medium">~5 minutes</span>
                    </div>
                </Card.Body>
                </Card>
            </Col>
            </Row>

            <h3 className="mb-5 mt-5">Sent Promotional SMS</h3>

                        <Table striped bordered hover responsive>
                          <thead>
                            <tr>
                            <th className="p-3 border-b">Campaign Name</th>
                            <th className="p-3 border-b">Message</th>
                            <th className="p-3 border-b">Recipients</th>
                            <th className="p-3 border-b">Sent At</th>
                            <th className="p-3 border-b">SMS Cost</th>
                            </tr>
                          </thead>
                           <tbody>
                    {campaigns.length === 0 ? (
                        <tr>
                            <td className="p-3 text-center text-gray-500" colSpan="5">No campaigns sent yet.</td>
                        </tr>
                    ) : (
                        campaigns.map(campaign => (
                            <tr key={campaign.id} className="hover:bg-gray-50">
                                <td className="p-3 border-b">{campaign.campaignName}</td>
                                <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={() => {
                                        setSelectedMessage(campaign.message);
                                        setShowModal(true);
                                    }}
                                    >
                                    View
                                </Button>
                                <td className="p-3 border-b">{campaign.totalRecipients}</td>
                                <td className="p-3 border-b">
                                    {campaign.sentAt?.toDate().toLocaleString()}
                                </td>
                                <td className="p-3 border-b">{campaign.smsCost}</td>
                            </tr>
                        ))
                    )}
                </tbody>
                        </Table>




            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Campaign Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ whiteSpace: "pre-wrap" }}>{selectedMessage}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
                </Button>
            </Modal.Footer>
            </Modal>


        </Card>

        </Container>

        
    </div>
    </div>
  );
}

export default SendBulkSMS;
